import { env } from '@/lib/env'

/**
 * URL pública do app (SPA) usada em snippets de embed e links externos.
 * Em produção, defina VITE_PUBLIC_APP_URL (ex.: https://app.seudominio.com).
 */
export function resolvePublicAppUrl(): string {
  const fromEnv = (env.publicAppUrl ?? '').trim().replace(/\/+$/, '')
  if (fromEnv) {
    return fromEnv
  }
  if (typeof window !== 'undefined') {
    return window.location.origin.replace(/\/+$/, '')
  }
  return ''
}
